import React, { useEffect, useState } from 'react';
import { JSON_ONE } from "./JSON_DATA_Request";
import { JSON_ONE1 } from "./JSON_DATA_Response";
import { JSON_ONE11 } from "./JSON_DATA_Requestflowone";
import { JSON_ONE21 } from "./JSON_DATA_Responseflowone";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import ResponseJSON from './ResponseJSON';
import RequestJSON from './RequestJSON';
import RequestJSONflowone from './RequestJSONflowone';
import ResponseJSONflowone from './ResponseJSONflowone';
import { Form } from 'react-router-dom';
import SettlementMISAPIDropDown from './SettlementMISAPItest/SettlementMISAPIDropDown';

function SettlementMISAPI() {
   const [ShowHideAccordionOne, SetShowHideAccordionOne] = useState(false);
   const [ShowHideAccordionTwo, SetShowHideAccordionTwo] = useState(false);
   const onClickAccordianShowHideOne = () => {
      SetShowHideAccordionOne(!ShowHideAccordionOne)
   }
   const onClickAccordianShowHideTwo = () => {
      SetShowHideAccordionTwo(!ShowHideAccordionTwo)
   }
   const [TabCheck, SetTabCheck] = useState(false)
   const [TabCheck1, SetTabCheck1] = useState(false)
   const [TabCheck2, SetTabCheck2] = useState(false)
   const onClickCangeTab = () => {
      SetTabCheck(!TabCheck);
   }
   const onClickCangeTab1 = () => {
      SetTabCheck1(!TabCheck1);
   }
   const onClickCangeTab2 = () => {
      SetTabCheck2(!TabCheck2);
   }
   return (
      <div class="idocs-content">
         <div class="">
            <div class="row">
               <div class="col-md-8">
                  <section id="idocs_layout1">
                     <h1>Settlement MIS API</h1>
                     <hr />
                  </section>
               </div>
               <div class="col-md-4 extreme-rt-div">
               </div>
            </div>
            <div class="row">
               <div class="col-md-8 mt-60">
                  <h2 id="login-api-settle-sec">Login API</h2>
                  <p>
                     This API can be used to download Settlement MIS without need to login in merchant dashboard portal.
                  </p>
                  <p>
                     Session Key is generated in this step, which needs to be sent in every request header along with UserId.
                  </p>
                  <p>
                     To download document for this API <a href="assets/pdf/SETTLEMENT MIS API.pdf" className="col-org">Click here</a>
                  </p>
                  <h5>
                     UAT Request URL:
                  </h5>
                  {/* <a className="col-red" href="https://pguat.safexpay.com/agadmin/api/signUpLogin/agId/paygate">https://pguat.safexpay.com/agadmin/api/signUpLogin/agId/paygate</a><br /><br /> */}
                  <a className="col-red" href="https://pguat.safexpay.com/agadmin/api/signUpLogin/agId/paygate" >https://checkout.safexpay.com/ms-transaction-core-1-0/api/settlementMis/userId/Ketan94/page_ids/0/limit_records/7</a><br /><br />
                  <h5>
                     Production URL:
                  </h5>
                  {/* <a className="col-red" href="https://www.avantgardepayments.com/agadmin/api/signUpLogin/agId/paygate">https://www.avantgardepayments.com/agadmin/api/signUpLogin/agId/paygate</a><br /><br /><br /> */}
                  <a className="col-red" href="https://www.avantgardepayments.com/agadmin/api/signUpLogin/agId/paygate">https://checkout.safexpay.com/ms-transaction-core-1-0/api/settlementMis/userId/Ketan94/page_ids/0/limit_records/7</a><br /><br /><br />
                  <h5>Request Parameters:</h5>
                  <table class="table table-bordered mt-20">
                     <tbody>
                        <tr>
                           <th>Name</th>
                           <th>Type</th>
                           <th>Mandatory</th>
                           <th>Remarks</th>
                        </tr>
                        <tr>
                           <td>loginRequest</td>
                           <td>String</td>
                           <td>Yes</td>
                           <td>This contains encrypted Json Array of Login Details, refer table below for the details</td>
                        </tr>
                     </tbody>
                  </table>
                  <h5>Decrypted Login Request Value:</h5>
                  <table class="table table-bordered mt-20">
                     <tbody>
                        <tr>
                           <th>Name</th>
                           <th>Type</th>
                           <th>Mandatory</th>
                           <th>Remarks</th>
                        </tr>
                        <tr>
                           <td>userId</td>
                           <td>String</td>
                           <td>Yes</td>
                           <td>Login Id</td>
                        </tr>
                        <tr>
                           <td>password</td>
                           <td>String</td>
                           <td>Yes</td>
                           <td></td>
                        </tr>
                     </tbody>
                  </table>
                  <h5>Response Parameters:</h5>
                  <table class="table table-bordered mt-20">
                     <tbody>
                        <tr>
                           <th>Name</th>
                           <th>Type</th>
                           <th>Remarks</th>
                        </tr>
                        <tr>
                           <td>Payload</td>
                           <td>String</td>
                           <td>This contains encrypted Json Array of response data</td>
                        </tr>
                        <tr>
                           <td>password</td>
                           <td>String</td>
                           <td>00 - Success, 01 - Failure</td>
                        </tr>
                        <tr>
                           <td>message</td>
                           <td>String</td>
                           <td>SUCCESS/FAILURE</td>
                        </tr>
                     </tbody>
                  </table>
                  <h5>Decrypted Payload Value:</h5>
                  <table class="table table-bordered mt-20">
                     <tbody>
                        <tr>
                           <th>Name</th>
                           <th>Type</th>
                           <th>Remarks</th>
                        </tr>
                        <tr>
                           <td>uniqueLoginKey</td>
                           <td>String</td>
                           <td>Key for encrypting data</td>
                        </tr>
                        <tr>
                           <td>merchantId</td>
                           <td>String</td>
                           <td>Logged in user’s merchant Id</td>
                        </tr>
                        <tr>
                           <td>fcmkey</td>
                           <td>String</td>
                           <td>Used for push notifications</td>
                        </tr>
                        <tr>
                           <td>agId</td>
                           <td>String</td>
                           <td>Aggregator Id</td>
                        </tr>
                        <tr>
                           <td>merchantKey</td>
                           <td>String</td>
                           <td>Merchant key</td>
                        </tr>
                        <tr>
                           <td>qrCodeImageUrl</td>
                           <td>String</td>
                           <td>Merchant QR code image URL</td>
                        </tr>
                        <tr>
                           <td>sessionKey</td>
                           <td>String</td>
                           <td>Encrypted session key to be passed in every request header</td>
                        </tr>
                     </tbody>
                  </table>
                  <h6><u>AUTHORIZATIONS:</u></h6>
                  <h6 className="mt-10">HEADER PARAMETERS</h6>
                  <hr class="hr-col">
                  </hr>
                  <table class="sc-hHEiqL iZJLLY">
                     <tbody>
                        <tr class="last undefined">
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="Content-Type">
                              <span class="sc-iemWCZ fhDkLh"></span><span>Content-Type</span>
                              <div class="sc-TtZnY sc-jHNicF ehnWxS imjMKL"> required </div>
                           </td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>Application-JSON</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                     </tbody>
                  </table>
                  <h6>REQUEST BODY SCHEMA:  application-json</h6>
                  <hr class="hr-col">
                  </hr>
                  <table class="sc-hHEiqL iZJLLY">
                     <tbody>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="userId"><span class="sc-iemWCZ fhDkLh"></span><span>userId</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>Login ID.</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr class="last undefined">
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="password"><span class="sc-iemWCZ fhDkLh"></span><span>password</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                     </tbody>
                  </table>
                  <h5 className="mt-30">Responses</h5>
                  <div class="accordion accordion-alterate arrow-right mt-30" id="popularTopics">
                     <div class="card">
                        <div class="card-header" id="heading1">
                           <h5 class="mb-0">
                              <div style={{ backgroundColor: "rgba(29, 129, 39, 0.07)", color: "rgb(29, 129, 39)", padding: "10px 15px" }} onClick={onClickCangeTab1}>
                                 <b>200</b> A reponse json object {TabCheck1 ?
                                    <FaAngleUp />
                                    :
                                    <FaAngleDown />
                                 }
                              </div>
                           </h5>
                        </div>
                        {
                           TabCheck1 &&
                           <div>
                              <div class="card-body">
                                 <h6 class="mt-10"><span>RESPONSE SCHEMA: </span> <span style={{ color: "#313131" }}>application/json</span></h6>
                                 <hr class="hr-col">
                                 </hr>
                                 <table class="sc-hHEiqL iZJLLY">
                                    <tbody>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="payload"><span class="sc-iemWCZ fhDkLh"></span><span>payload</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>This contains encrypted Json Array of response data.</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="statusCode"><span class="sc-iemWCZ fhDkLh"></span><span>statusCode</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>00 - Success, 01 - Failure.</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr class="last undefined">
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="message"><span class="sc-iemWCZ fhDkLh"></span><span>message</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>SUCCESS/FAILURE.</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                    </tbody>
                                 </table>
                              </div>
                           </div>
                        }
                     </div>
                     <div class="card">
                        <div class="card-header">
                           <h5 class="mb-0"> <span>400 Bad request</span> </h5>
                        </div>
                     </div>
                     <div class="card">
                        <div class="card-header">
                           <h5 class="mb-0"> <span>401 Unauthorized</span> </h5>
                        </div>
                     </div>
                     <div class="card">
                        <div class="card-header">
                           <h5 class="mb-0"> <span>404 Not found</span> </h5>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="col-md-4 extreme-rt-div">
                  <div class="accordion accordion-alterate arrow-right mt-60 side-api" id="popularTopics">
                     <div class="card">
                        <div class="card-header" id="heading1">
                           <h5 class="mb-0">
                              <div style={{ backgroundColor: "rgb(17 23 26)", color: "#fff" }} onClick={onClickCangeTab}>
                                 <button> POST </button> /api/signUpLogin/agId/ paygate/ {TabCheck ?
                                    <FaAngleUp />
                                    :
                                    <FaAngleDown />
                                 }
                              </div>
                           </h5>
                        </div>
                        {
                           TabCheck &&
                           <div>
                              <br />
                              <div class="card-body">
                                 <p class="mb-0">Production server (uses live data)</p>
                                 <div class="api-div-bor">
                                    <span>https://www.avantgardepayments.com</span><span
                                       class="col-org">/agadmin/api/signUpLogin/agId/paygate/</span>
                                 </div>
                                 <p class="mb-0 mt-20">Sandbox server (uses test data)</p>
                                 <div class="api-div-bor">
                                    <span>https://pguat.safexpay.com</span><span
                                       class="col-org">/agadmin/api/signUpLogin/agId/paygate/</span>
                                 </div>
                              </div>
                           </div>
                        }
                     </div>
                  </div>
                  <RequestJSON />
                  <ResponseJSON />
               </div>
            </div>
            <SettlementMISAPIDropDown />
         </div>
      </div>
   )
}
export default SettlementMISAPI